export default __webpack_public_path__ + "static/media/pic7.072e742c.jpg";